
// Facebook Pixel tracking service
declare global {
  interface Window {
    fbq: any;
  }
}

export class FacebookPixel {
  private static pixelId: string = '601612312971206';
  private static initialized: boolean = false;

  static init() {
    if (this.initialized || typeof window === 'undefined') return;

    // Load Facebook Pixel script
    (function(f: any, b: any, e: any, v: any, n?: any, t?: any, s?: any) {
      if (f.fbq) return;
      n = f.fbq = function() {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = '2.0';
      n.queue = [];
      t = b.createElement(e);
      t.async = !0;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t, s);
    })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');

    window.fbq('init', this.pixelId);
    window.fbq('track', 'PageView');
    
    this.initialized = true;
    console.log('Facebook Pixel initialized');
  }

  static trackEvent(eventName: string, parameters?: any) {
    if (!this.initialized) {
      console.warn('Facebook Pixel not initialized');
      return;
    }

    try {
      window.fbq('track', eventName, parameters);
      console.log(`Facebook Pixel event tracked: ${eventName}`, parameters);
    } catch (error) {
      console.error('Error tracking Facebook Pixel event:', error);
    }
  }

  static trackCustomEvent(eventName: string, parameters?: any) {
    if (!this.initialized) {
      console.warn('Facebook Pixel not initialized');
      return;
    }

    try {
      window.fbq('trackCustom', eventName, parameters);
      console.log(`Facebook Pixel custom event tracked: ${eventName}`, parameters);
    } catch (error) {
      console.error('Error tracking Facebook Pixel custom event:', error);
    }
  }

  // Predefined tracking methods for your specific events
  static trackSignUp() {
    this.trackEvent('CompleteRegistration');
  }

  static trackPurchaseInitiated(value?: number, currency?: string) {
    this.trackEvent('InitiateCheckout', {
      value: value || 0,
      currency: currency || 'USD'
    });
  }

  static trackPurchase(value: number, currency: string = 'USD') {
    this.trackEvent('Purchase', {
      value: value,
      currency: currency
    });
  }
}
